/**
 * render-weekly-report
 *
 * @author    Richard J. Turner <richard.turner@mediatel.co.uk>
 * @copyright 2015 Mediatel Limited.
 */

"use strict";

export default (data, filter) => data.filter(
    s => filter ? s.station_name.match(new RegExp("^" + filter, "i")) : true
).map(
    (row, i) => `<tr id="station_${row.station_id}" class="${i % 2 === 0 ? "even" : "odd"}${row.station_id === "46" ? " summary" : ""}">` +
    `<td>${row.station_name}</td>` +
    `<td class="number align_right">${(row.daily_value) ? row.daily_value.toLocaleString() : "n/a"}</td>` +
    `<td class="percentage align_right">${(row.daily_reach) ? row.daily_reach.toLocaleString() : "n/a"}</td>` +
    `<td class="number align_right">${(row.weekly_value) ? row.weekly_value.toLocaleString() : "n/a"}</td>` +
    `<td class="percentage align_right">${(row.weekly_reach) ? row.weekly_reach.toLocaleString() : "n/a"}</td>` +
    `<td class="minutage align_right">${(row.minutes) ? row.minutes : "n/a"}</td>` +
    `<td class="share align_right">${(row.viewing_share) ? row.viewing_share.toLocaleString() : "n/a"}</td>` +
    "</tr>"
).join("\n");

